import { toast } from "sonner";
import { X } from "lucide-react";

const PRESETS = [
  { nombre: "Solo óptica", rx: /^(ana|ángel|angel)/i },
  { nombre: "Solo terapia", rx: /^(natalia|laura|pilar)/i },
];
const leer = () => JSON.parse(localStorage.getItem("agenda_vistas") || "[]");

export const VistasRapidas = ({ profs, ocultos, setOcultos }) => {
  const guardadas = leer();
  const aplicar = (mostrar) => setOcultos(profs.filter((p) => !mostrar.includes(p.id)).map((p) => p.id));
  const guardar = () => {
    const nombre = window.prompt("Nombre para esta vista (se guardan las profesionales que ves ahora):");
    if (!nombre?.trim()) return;
    const v = [...leer().filter((x) => x.nombre !== nombre.trim()), { nombre: nombre.trim(), ids: profs.filter((p) => !ocultos.includes(p.id)).map((p) => p.id) }];
    localStorage.setItem("agenda_vistas", JSON.stringify(v));
    setOcultos([...ocultos]);
    toast.success(`Vista «${nombre.trim()}» guardada`);
  };
  const borrar = (n) => {
    localStorage.setItem("agenda_vistas", JSON.stringify(leer().filter((x) => x.nombre !== n)));
    setOcultos([...ocultos]);
  };
  const btn = "rounded-md border border-slate-300 bg-white px-2 py-0.5 font-medium text-slate-700 transition-colors hover:bg-slate-50";
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5 ml-3" data-testid="agenda-vistas">
      <span className="font-semibold text-slate-500">Vistas:</span>
      {PRESETS.map((v) => <button key={v.nombre} type="button" className={btn} data-testid={`vista-${v.nombre}`} onClick={() => aplicar(profs.filter((p) => v.rx.test(p.nombre)).map((p) => p.id))}>{v.nombre}</button>)}
      {guardadas.map((v) => (
        <span key={v.nombre} className="inline-flex items-center rounded-md border border-[#1E3A8A]/40 bg-sky-50">
          <button type="button" className="px-2 py-0.5 font-medium text-[#1E3A8A]" data-testid={`vista-${v.nombre}`} onClick={() => aplicar(v.ids)}>{v.nombre}</button>
          <button type="button" className="pr-1 text-slate-400 hover:text-rose-600" onClick={() => borrar(v.nombre)} data-testid={`vista-borrar-${v.nombre}`} aria-label="Borrar vista"><X className="h-3 w-3" /></button>
        </span>
      ))}
      <button type="button" className={`${btn} border-dashed`} onClick={guardar} data-testid="vista-guardar">+ Guardar esta vista</button>
    </span>
  );
};
